{
  "title": "Spirit of Death (UA)",
  "source": "Unearthed Arcana 85 - Wonders of the Multiverse",
  "levelAndSchool": "4th-level necromancy",
  "level": 4,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (a gilded playing card depicting an avatar of death worth at least 400 gp)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You call forth a spirit that embodies death itself. Choose a creature you can see within range. The spirit manifests in an unoccupied space that you can see within 10 feet of the target, and the target becomes haunted by the spirit. The spirit uses the Reaper Spirit stat block. The spirit disappears when it or the haunted creature is reduced to 0 hit points, or when the spell ends.",
    "The reaper spirit is an ally to you and your companions. In combat, the spirit shares your initiative count, but it takes its turn immediately after yours. It obeys your verbal commands (no action required by you), but it will only attack the haunted creature. If you don’t issue the spirit any commands, it takes the Dodge action and uses its move to avoid danger",
    "At Higher Levels. When you cast this spell using a spell slot of 5th level or higher, use the higher level wherever the spell’s level appears in the stat block.",
    "Reaper Spirit",
    "Medium Undead",
    "Armor Class: 11 + the level of the spell (natural armor)",
    "Hit Points: 40 + 10 for each level of the spell above 4th",
    "Speed: 30 ft., fly 30 ft. (hover)",
    "STR",
    "DEX",
    "CON",
    "INT",
    "WIS",
    "CHA",
    "16 (+3)",
    "16 (+3)",
    "16 (+3)",
    "16 (+3)",
    "16 (+3)",
    "16 (+3)",
    "Damage Immunities: necrotic, poison",
    "Condition Immunities: charmed, frightened, paralyzed, poisoned",
    "Senses: darkvision 60 ft., passive Perception 13",
    "Languages: understands the languages you speak",
    "Challenge: —",
    "Proficiency Bonus: equals your bonus",
    "Incorporeal Movement. The reaper can move through other creatures and objects as if they were difficult terrain. If it ends its turn inside an object, it is shunted to the nearest unoccupied space and takes 1d10 force damage for every 5 feet traveled.",
    "Haunting Tracker. You and the reaper can sense the direction and distance to the haunted creature if it’s on the same plane of existence as you.",
    "Actions",
    "Multiattack. The reaper makes a number of attacks equal to half this spell’s level (rounded down).",
    "Reaping Scythe. Melee Weapon Attack: your spell attack modifier to hit (with advantage), reach 5 ft., one target. Hit: 1d10 + 3 + the spell’s level necrotic damage.",
    "Paralyzing Fear (1/Day). The reaper attempts to instill fear into the haunted creature it can see within 60 feet of itself. The creature must succeed on a Wisdom saving throw against your spell save DC or be frightened of the reaper for 1 minute. While frightened this way, the creature’s speed is 0, and it can’t benefit from any bonus to its speed. The frightened creature can repeat the saving throw at the end of each of its turns, or immediately after it takes damage, ending the effect on itself on a success."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
